import { Gender, parseDate } from 'rlv-common';
import { PersonalPageData, SetStateHandlerArg } from '../pages/personalData/PersonalDataPage.types';
import { HandleActionCallback } from '../routing/StateMachine';
import { NavigationAction } from '../routing/StateMachineTypes';
import { handleFormErrors } from '../tracking/trackingFormating';
import { VnInput } from '../types/external/personendatenerfassung/messaging/model/input/VnInput';

export const noActionSelected = () => undefined;
export const createVn = (
  userInput: PersonalPageData,
  duwGeschlecht: Gender | undefined,
): VnInput => ({
    ...userInput,
    // TODO: workaround: remove tagDerAbbuchung after the backend calls the PDS to get initial data.
    tagDerAbbuchung: undefined,
    id: userInput.pdeId,
    geschlecht: duwGeschlecht ? duwGeschlecht : userInput.geschlecht,
    isGWGRequired: false,
    geburtsdatum: parseDate(userInput.birthdate),
    isIbanAlwaysVisible: true,
    showGeburtsort: true,
    showStaatsangehoerigkeit: true,
    hasInternationalIbanSupport: true,
    isEMailOptional: false,
    showEmailConfirmationTooltip: false,
    showSepaBankInfo: false,
    isSexReadOnly: false,
    role: '',
  });

export const actionAfterSaving = (
  action: NavigationAction,
  pdeValid: boolean,
  isEmailMandatoryValid: boolean | undefined,
  handleAction: HandleActionCallback,
  setStateHandler: (newState: SetStateHandlerArg) => void,
) => {
  if (
    getIsAllPdePageDataValid(pdeValid, isEmailMandatoryValid) ||
    NavigationAction.BACK === action
  ) {
    handleAction(action);
  } else {
    handleSavingErrors(setStateHandler);
  }
};

const handleSavingErrors = (setStateHandler: (newState: SetStateHandlerArg) => void) => {
  setStateHandler({
    showGlobalErrorMessages: true,
    isLoading: false,
    actionAfterSaving: noActionSelected,
  });
};

export const getIsAllPdePageDataValid = (
  pdeValid: boolean,
  isEmailMandatoryValid: boolean | undefined,
): boolean => getErrorMessages(pdeValid, isEmailMandatoryValid).length === 0;

export const getErrorMessages = (
  pdeValid: boolean,
  isEmailMandatoryValid: boolean | undefined,
): string[] => {
  const errorMessages: string[] = [];
  if (!pdeValid) {
    handleFormErrors('Die versicherte Person ist nicht valide');
    errorMessages.push('Die versicherte Person ist nicht valide');
  }
  if (!isEmailMandatoryValid && !pdeValid) {
    errorMessages.push('Bitte geben Sie ein gültige E-mail address ein.');
  }
  return errorMessages;
};
